const formatValidity = (validity, t) => {
  const year = Math.floor(validity / 518400)
  const months = Math.floor(validity / 42800)
  const days = Math.floor(validity / 1440)
  const hours = Math.floor((validity % 1440) / 60)
  const minutes = validity - days * 1440 - hours * 60
  const result = []
  if (year > 0 ) {
    result.push(t('coupons.table.validity_col.years', { count: year }))
  }
  if (months > 0 ) {
    result.push(t('coupons.table.validity_col.months', { count: months }))
  }
  if (days > 0) {
    result.push(t('coupons.table.validity_col.days', { count: days }))
  }
  if (hours > 0) {
    result.push(t('coupons.table.validity_col.hours', { count: hours }))
  }
  if (minutes > 0) {
    result.push(t('coupons.table.validity_col.minutes', { count: minutes }))
  }
  return result
}

export default formatValidity
